import { frontendURL } from '../../../helper/URLHelper';

const MainDashboard = () => import('./MainDashboard.vue');

// All users can access dashboard - content is filtered by role
const meta = {
  permissions: ['administrator', 'agent', 'report_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/overview'),
    name: 'main_dashboard',
    component: MainDashboard,
    meta,
  },
];
